import { NgModule } from '@angular/core';
import * as fromCJ from './store/reducer';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { EfaactMaterialModule } from '../efaact-material/efaact-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MultiSelectModule, DropdownModule, MenuModule, TreeTableModule } from '../shared/efaact-primeng.module';
import { SharedModule } from '../shared/shared.module';
import { ContractStructureFeaturesComponent } from './features/contract-structure-features.component';
import { ContractStructurePresentersComponent } from './presenters/contract-structure-presenters.component';
import { CustomerJobEffects } from './store/effects';
import { ExpensesModule } from '../expenses';


@NgModule({
  imports: [
    CommonModule
    , StoreModule.forFeature('customerjob', fromCJ.reducer)
    , EffectsModule.forFeature([CustomerJobEffects])
    , EfaactMaterialModule
    , FormsModule
    , ReactiveFormsModule
    , MultiSelectModule
    , DropdownModule
    , SharedModule
    , ExpensesModule
    , MenuModule
    , TreeTableModule
  ],
  declarations: [ContractStructureFeaturesComponent, ContractStructurePresentersComponent],
})
export class CustomerJobModule { }
